/**
 * SoCalGas utility filing industrial therms (Burbank).
 * Source: SoCalGas_2021_2024_correct.xlsx — CITY OF BURBANK / INDUSTRIAL rows.
 * Not ingested into ng_com_format; Analysis canonical only.
 */
/** Filing years used for industrial (2021 excluded — partial filing vs later years). */
export const BURBANK_SOCAL_INDUSTRIAL_GAS_THERMS_BY_YEAR: Readonly<Record<number, number>> = {
  2022: 116_064_597,
  2023: 122_307_019,
  2024: 118_591_983,
};

export const BURBANK_SOCAL_INDUSTRIAL_GAS_FILING_YEARS = Object.keys(
  BURBANK_SOCAL_INDUSTRIAL_GAS_THERMS_BY_YEAR
)
  .map(Number)
  .sort((a, b) => a - b);

export function burbankSoCalIndustrialGasTherms(year: number): number | null {
  return BURBANK_SOCAL_INDUSTRIAL_GAS_THERMS_BY_YEAR[year] ?? null;
}
